export const APP_NOTIFICATION_DELETE_ITEM = "APP_NOTIFICATION_DELETE_ITEM";
export const APP_NOTIFICATION_GET_ITEMS = "APP_NOTIFICATION_GET_ITEMS";
export const APP_NOTIFICATION_ADD_NEW = "APP_NOTIFICATION_ADD_NEW";
export const APP_NOTIFICATION_UPDATE = "APP_NOTIFICATION_UPDATE";